import { SiteInfo } from '../models/SiteInfo';
import { Storage, API } from 'aws-amplify';
import { InferenceResult } from '../models/InferenceResult';
import { InferenceResultSubdiv } from '../models/InferenceResultSubdiv';
import { InferenceResultObsrec } from '../models/InferenceResultObsrec';
import { KansatsuKiroku } from '../models/KansatsuKiroku';
import { KansatsuKirokuSubdiv } from '../models/KansatsuKirokuSubdiv';
import { KansatsuKirokuObsrec } from '../models/KansatsuKirokuObsrec';
import { InferenceAdditionalResult } from '../models/InferenceAdditionalResult';
import { InferenceAdditionalResultSubdiv } from '../models/InferenceAdditionalResultSubdiv';
import { InferenceAdditionalResultObsrec } from '../models/InferenceAdditionalResultObsrec';

export const listSiteInfo = async (): Promise<SiteInfo[]> => {
  const response = await API.get('CutoutApi', '', {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (response && response.length > 0) {
    return response.map(item => (
      {
        koujiBangou: item.tunnel_no,
        name: item.tunnel_name,
        cropImageWidth: item.crop_image_width,
        cropImageHeight: item.crop_image_height
      }));
  }
  return []
};
export const listSiteInfoSubdiv = async (): Promise<SiteInfo[]> => {
  const response = await API.get('CutoutSubdivApi', '', {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (response && response.length > 0) {
    return response.map(item => (
      {
        koujiBangou: item.tunnel_no,
        name: item.tunnel_name,
        cropImageWidth: item.crop_image_width,
        cropImageHeight: item.crop_image_height,
        lineNum: item.line_num,
        columnNum: item.column_num,
        observationNames: item.observation_names ? item.observation_names.split(',') : [],
        observationDescriptions: item.observation_description ? item.observation_description.split(',') : [],

        // 段階ルールを適応
        targetStepRuleObservationNames: item.target_step_rule_observation_names ? item.target_step_rule_observation_names.split(',') : [],
        targetStepRuleObservations: item.target_step_rule_observations ? item.target_step_rule_observations.split(',') : [],
        // 最頻値パターンを適応
        targetModeRuleObservationNames: item.target_mode_rule_observation_names ? item.target_mode_rule_observation_names.split(',') : [],
        targetModeRuleObservations: item.target_mode_rule_observations ? item.target_mode_rule_observations.split(',') : [],
        // 平均<スコア重複排除前提>を適応
        targetMeanDeduplicationRuleObservationNames: item.target_mean_deduplication_rule_observation_names ? item.target_mean_deduplication_rule_observation_names.split(',') : [],
        targetMeanDeduplicationRuleObservations: item.target_mean_deduplication_rule_observations ? item.target_mean_deduplication_rule_observations.split(',') : [],
        // 平均<一般>を適応
        targetMeanGeneralRuleObservationNames: item.target_mean_general_rule_observation_names ? item.target_mean_general_rule_observation_names.split(',') : [],
        targetMeanGeneralRuleObservations: item.target_mean_general_rule_observations ? item.target_mean_general_rule_observations.split(',') : [],

        // 小計・合計に含めるか
        isIncludeInSubtotalObservations: item.is_include_in_subtotal ? item.is_include_in_subtotal.split(',') : [],
        isIncludeInTotalObservations: item.is_include_in_total ? item.is_include_in_total.split(',') : [],
        // 切羽評価点換算表データ
        excavationFaceScoreConversionTableData: item.excavation_face_score_conversion_table_data || [],
        // 観察項目マッピング
        observationMap: item.observation_map,

        topBadsideSize: item.top_badside_size,
        leftBadsideSize: item.left_badside_size,
        rightBadsideSize: item.right_badside_size
      }));
  }
  return []
};
export const listSiteInfoObsrec = async (): Promise<SiteInfo[]> => {
  const response = await API.get('CutoutObsrecApi', '', {
    headers: {
      'Content-Type': 'application/json',
    }
  });
  if (response && response.length > 0) {
    return response.map(item => (
      {
        koujiBangou: item.tunnel_no,
        name: item.tunnel_name,
        cropImageWidth: item.crop_image_width,
        cropImageHeight: item.crop_image_height,
        lineNum: item.line_num,
        columnNum: item.column_num,
        observationNames: item.observation_names.split(','),
        observationDescriptions: item.observation_description.split(','),
        obsrecWeights: item.weight_info,

        // 段階ルールを適応
        targetStepRuleObservationNames: item.target_step_rule_observation_names.split(','),
        targetStepRuleObservations: item.target_step_rule_observations.split(','),
        // 最頻値パターンを適応
        targetModeRuleObservationNames: item.target_mode_rule_observation_names.split(','),
        targetModeRuleObservations: item.target_mode_rule_observations.split(','),
        // 平均<スコア重複排除前提>を適応
        targetMeanDeduplicationRuleObservationNames: item.target_mean_deduplication_rule_observation_names.split(','),
        targetMeanDeduplicationRuleObservations: item.target_mean_deduplication_rule_observations.split(','),
        // 平均<一般>を適応
        targetMeanGeneralRuleObservationNames: item.target_mean_general_rule_observation_names.split(','),
        targetMeanGeneralRuleObservations: item.target_mean_general_rule_observations.split(','),

        topBadsideSize: item.top_badside_size,
        leftBadsideSize: item.left_badside_size,
        rightBadsideSize: item.right_badside_size
      }));
  }
  return []
};
/**
 * base64エンコードされた画像をデコードする
 */
const decodeImage = async (imageStr: string, contentType: string): Promise<any> => {
  return fetch(`data:${contentType};base64,${imageStr}`).then(response => response.blob());
};

export const uploadImage = async ({ key, imageStr, contentType }: { key: string, imageStr: string, contentType: string }): Promise<any> =>
  new Promise((resolve, reject) => {
    // customPrefixを空文字にして指定したkeyで直接配置する
    const StorageOption = {
      customPrefix: {
        public: ''
      },
      contentType
    };
    // 画像をデコード
    decodeImage(imageStr, contentType)
      .then((image) => {
        Storage.put(key, image, StorageOption)
          .then((result) => {
            resolve(result);
          })
          .catch(err => reject(err));
      })
      .catch((err) => {
        console.error('画像のデコードでエラー', err);
        reject(err);
      });
  });


export const inference = async (
  {
    koujiBangou,
    inferenceId,
    imagePath
  }: {
    koujiBangou: string
    inferenceId: string
    imagePath: string
  }
): Promise<{
  results: InferenceResult[],
  additionalResult: InferenceAdditionalResult
}> => {
  const response = await API.get('PredictApi', '', {
    headers: {
      'Content-Type': 'application/json'
    },
    queryStringParameters: {
      tunnel_no: koujiBangou,
      inference_id: inferenceId,
      inference_img_file_path: imagePath
    }
  });
  return {
    results: response.results.observation_score,
    additionalResult: response.results.additional_score
  };
};
export const inferenceSubdiv = async (
  {
    koujiBangou,
    inferenceId,
    imagePath
  }: {
    koujiBangou: string
    inferenceId: string
    imagePath: string
  }
): Promise<{
  results: InferenceResultSubdiv[],
  additionalResult: InferenceAdditionalResultSubdiv,
  coordinatesResults: KansatsuKirokuObsrec['observationsScores']
}> => {
  // 推論は結果を待たずに投げっぱなしで、GetResultを結果が取得できるまで繰り返す
  API.get('PredictSubdivApi', '', {
    headers: {
      'Content-Type': 'application/json'
    },
    queryStringParameters: {
      tunnel_no: koujiBangou,
      inference_id: inferenceId,
      inference_img_file_path: imagePath
    }
  });
  return new Promise((resolve, reject) => {
    // getresultを呼び出す関数を定義し、INTERVAL_SEC秒ごとに呼び出す
    // 最大繰り返しはMAX_RETRY回
    const INTERVAL_SEC = 5;
    const MAX_RETRY = 24;
    let retries = 0;
    const f = async () => {
      try {
        const response = await API.get('GetResultSubdivApi', '', {
          headers: {
            'Content-Type': 'application/json'
          },
          queryStringParameters: {
            tunnel_no: koujiBangou,
            inference_id: inferenceId,
            inference_img_file_path: imagePath
          }
        });
        // 処理結果にresultsが含まれていれば終了
        if (response.results) {
          resolve({
            results: response.results.observation_score,
            additionalResult: response.results.additional_score,
            coordinatesResults: response.results.coordinates_predict_result
          });
        } else {
          // 結果が空振りの場合はリトライする
          if (retries < MAX_RETRY) {
            retries += 1;
            setTimeout(f, INTERVAL_SEC * 1000);
          } else {
            // 最大リトライ回数を超えた場合はエラーで終了する。
            reject(new Error(`推論結果取得の最大リトライ回数${MAX_RETRY}を超えました。`));
          }
        }
      } catch (e) {
        reject(e);
      }
    };

    f();

    // // return {
    // //   results: response.results.observation_score,
    // //   additionalResult: response.results.additional_score
    // // };
    // API.get('GetResultSubdivApi', '', {
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   queryStringParameters: {
    //     tunnel_no: koujiBangou,
    //     inference_id: inferenceId,
    //     inference_img_file_path: imagePath
    //   }
    // }).then((result) => {
    //   console.log(result);
    //   resolve(result);
    // }).catch((e) => reject(e));
  });
};

export const inferenceObsrec = async (
  {
    koujiBangou,
    inferenceId,
    imagePath
  }: {
    koujiBangou: string
    inferenceId: string
    imagePath: string
  }
): Promise<{
  results: InferenceResultObsrec[],
  additionalResult: InferenceAdditionalResultObsrec
}> => {
  // 推論は結果を待たずに投げっぱなしで、GetResultを結果が取得できるまで繰り返す
  API.get('PredictObsrecApi', '', {
    headers: {
      'Content-Type': 'application/json'
    },
    queryStringParameters: {
      tunnel_no: koujiBangou,
      inference_id: inferenceId,
      inference_img_file_path: imagePath
    }
  });
  return new Promise((resolve, reject) => {
    // getresultを呼び出す関数を定義し、INTERVAL_SEC秒ごとに呼び出す
    // 最大繰り返しはMAX_RETRY回
    const INTERVAL_SEC = 5;
    const MAX_RETRY = 24;
    let retries = 0;
    const f = async () => {
      try {
        const response = await API.get('GetResultObsrecApi', '', {
          headers: {
            'Content-Type': 'application/json'
          },
          queryStringParameters: {
            tunnel_no: koujiBangou,
            inference_id: inferenceId,
            inference_img_file_path: imagePath
          }
        });
        // 処理結果にresultsが含まれていれば終了
        if (response.results) {
          resolve({
            results: response.results.observation_score,
            additionalResult: response.results.additional_score
          });
        } else {
          // 結果が空振りの場合はリトライする
          if (retries < MAX_RETRY) {
            retries += 1;
            setTimeout(f, INTERVAL_SEC * 1000);
          } else {
            // 最大リトライ回数を超えた場合はエラーで終了する。
            reject(new Error(`推論結果取得の最大リトライ回数${MAX_RETRY}を超えました。`));
          }
        }
      } catch (e) {
        reject(e);
      }
    };

    f();
  });
};

export const fetchKansatsuKiroku = async (
  {
    koujiBangou
  }: {
    koujiBangou: string
  }
): Promise<{
  Items: KansatsuKiroku[]
}> => {
  const path = `/${koujiBangou}`;
  const response = await API.get('KansatsuKirokuApi', path, {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response;
};

export const getKansatsuKiroku = async (
  {
    koujiBangou,
    key
  }: {
    koujiBangou: string,
    key: string
  }
): Promise<KansatsuKiroku> => {
  const path = `/${koujiBangou}/${key}`;
  const response = await API.get('KansatsuKirokuApi', path, {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response;
};

export const postKansatsuKiroku = async (
  {
    item
  }: {
    item: KansatsuKiroku
  }
): Promise<{}> => {
  const path = `/${item.koujiBangou}/${item.key}`;
  const response = await API.post('KansatsuKirokuApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    body: item
  });

  return response;
};

// export const oldFetchKansatsuKirokuSubdiv = async (
//   {
//     koujiBangou
//   }: {
//     koujiBangou: string
//   }
// ): Promise<{
//   Items: KansatsuKirokuSubdiv[]
// }> => {
//   const path = `/${koujiBangou}`;
//   const response = await API.get('KansatsuKirokuSubdivApi', path, {
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   });

//   return response;
// };

// export const oldFetchKansatsuKirokuObsrec = async (
//   {
//     koujiBangou
//   }: {
//     koujiBangou: string
//   }
// ): Promise<{
//   Items: KansatsuKirokuObsrec[]
// }> => {
//   const path = `/${koujiBangou}`;
//   const response = await API.get('KansatsuKirokuObsrecApi', path, {
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   });
//   return response;
// };

export const getKansatsuKirokuSubdiv = async (
  {
    koujiBangou,
    key
  }: {
    koujiBangou: string,
    key: string
  }
): Promise<KansatsuKirokuSubdiv> => {
  const path = `/${koujiBangou}/${key}`;
  const response = await API.get('KansatsuKirokuSubdivApi', path, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response;
};

export const getKansatsuKirokuObsrec = async (
  {
    koujiBangou,
    key
  }: {
    koujiBangou: string,
    key: string
  }
): Promise<KansatsuKirokuObsrec> => {
  const path = `/${koujiBangou}/${key}`;
  const response = await API.get('KansatsuKirokuObsrecApi', path, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response;
};

export const getLatestKansatsuKirokuObsrec = async ({ koujiBangou }: { koujiBangou: string }): Promise<KansatsuKirokuObsrec> => {

  const response = await API.get('GetLatestKansatsuKirokuObsrecApi', '', {
    headers: {
      'Content-Type': 'application/json'
    },
    queryStringParameters: {
      tunnel_no: koujiBangou
    }
  });
  if (response && response.length > 0) {
    const forRes = new KansatsuKirokuObsrec;
    forRes.observationsScores = JSON.parse(response)
    return forRes;
  }

  return new KansatsuKirokuObsrec;
};

export const fetchKansatsuKirokuSubdiv = async ({ koujiBangou }: { koujiBangou: string }): Promise<{ Items: KansatsuKirokuSubdiv[] }> => {
  try {
    const response = await API.get('GetKansatsuKirokuListSubdivApi', '', {
      headers: {
        'Content-Type': 'application/json'
      },
      queryStringParameters: {
        tunnel_no: koujiBangou
      }
    });
    // API.getのレスポンスがオブジェクトであれば、そのまま使用
    const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;
    if (parsedResponse && parsedResponse.length > 0) {
      const items = parsedResponse.map(item => item as KansatsuKirokuSubdiv);
      return { Items: items };
    }
    return { Items: [] };
  } catch (error) {
    console.error('Error fetching data:', error);
    if (error.response) {
      console.error('Response error data:', error.response.data);
      console.error('Response error status:', error.response.status);
      console.error('Response error headers:', error.response.headers);
    } else if (error.request) {
      console.error('Request error data:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    return { Items: [] };
  }
};

export const fetchKansatsuKirokuObsrec = async ({ koujiBangou }: { koujiBangou: string }): Promise<{ Items: KansatsuKirokuObsrec[] }> => {
  try {
    const response = await API.get('GetKansatsuKirokuListObsrecApi', '', {
      headers: {
        'Content-Type': 'application/json'
      },
      queryStringParameters: {
        tunnel_no: koujiBangou
      }
    });
    // API.getのレスポンスがオブジェクトであれば、そのまま使用
    const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;
    if (parsedResponse && parsedResponse.length > 0) {
      const items = parsedResponse.map(item => item as KansatsuKirokuObsrec);
      return { Items: items };
    }
    return { Items: [] };
  } catch (error) {
    console.error('Error fetching data:', error);
    if (error.response) {
      console.error('Response error data:', error.response.data);
      console.error('Response error status:', error.response.status);
      console.error('Response error headers:', error.response.headers);
    } else if (error.request) {
      console.error('Request error data:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    return { Items: [] };
  }
};


export const postKansatsuKirokuSubdiv = async (
  {
    item
  }: {
    item: KansatsuKirokuSubdiv
  }
): Promise<{}> => {
  const path = `/${item.koujiBangou}/${item.key}`;
  const response = await API.post('KansatsuKirokuSubdivApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    body: item
  });
  return response;
};


export const postKansatsuKirokuObsrec = async (
  {
    item
  }: {
    item: KansatsuKirokuObsrec
  }
): Promise<{}> => {
  const path = `/${item.koujiBangou}/${item.key}`;
  const response = await API.post('KansatsuKirokuObsrecApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    body: item
  });
  return response;
};

export const getEndpointStatus = async (
  {
    koujiBangou
  }: {
    koujiBangou: string
  }
): Promise<{ status: string }> => {
  const path = '';
  const response = await API.get('EndpointStatusApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    queryStringParameters: {
      tunnel_no: koujiBangou
    }
  });
  return response;
};

export const getEndpointStatusSubdiv = async (
  {
    koujiBangou
  }: {
    koujiBangou: string
  }
): Promise<{ status: string }> => {
  const path = '';
  const response = await API.get('EndpointStatusSubdivApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    queryStringParameters: {
      tunnel_no: koujiBangou
    }
  });
  return response;
};

export const deleteEndpoint = async (
  { koujiBangou, operationKey }: { koujiBangou: string; operationKey: string })
  : Promise<{ success: boolean, message: string }> =>
  endpointOperation({ koujiBangou, operationKey, operation: 'delete' });

export const createEndpoint = async (
  { koujiBangou, operationKey }: { koujiBangou: string; operationKey: string })
  : Promise<{ success: boolean, message: string }> =>
  endpointOperation({ koujiBangou, operationKey, operation: 'create' });

const endpointOperation = async (
  { koujiBangou, operationKey, operation }: { koujiBangou: string; operationKey: string; operation: string })
  : Promise<{ success: boolean, message: string }> => {
  const path = '';
  try {
    const response = await API.post('EndpointOperationApi', path, {
      headers: {
        'Content-Type': 'application/json'
      },
      body: {
        tunnel_no: koujiBangou,
        operation_key: operationKey,
        operation
      }
    });
    return {
      message: response.message,
      success: (response.success === 'true') || (response.success === true)
    };
  } catch (e) {
    // StatusCodeがエラーの場合、API側からbodyにmessageが設定されていればそれを返して正常終了とする。
    // それ以外はエラーとして扱う。
    if (e.response && e.response.data && e.response.data.message) {
      return {
        message: e.response.data.message,
        success: (e.response.data.success === 'true') || (e.response.data.success === true)
      };
    }
    throw e;
  }
};

export const deleteEndpointSubdiv = async (
  { koujiBangou, operationKey }: { koujiBangou: string; operationKey: string })
  : Promise<{ success: boolean, message: string }> =>
  endpointOperationSubdiv({ koujiBangou, operationKey, operation: 'delete' });

export const createEndpointSubdiv = async (
  { koujiBangou, operationKey }: { koujiBangou: string; operationKey: string })
  : Promise<{ success: boolean, message: string }> =>
  endpointOperationSubdiv({ koujiBangou, operationKey, operation: 'create' });

const endpointOperationSubdiv = async (
  { koujiBangou, operationKey, operation }: { koujiBangou: string; operationKey: string; operation: string })
  : Promise<{ success: boolean, message: string }> => {
  const path = '';
  try {
    const response = await API.post('EndpointOperationSubdivApi', path, {
      headers: {
        'Content-Type': 'application/json'
      },
      body: {
        tunnel_no: koujiBangou,
        operation_key: operationKey,
        operation
      }
    });
    return {
      message: response.message,
      success: (response.success === 'true') || (response.success === true)
    };
  } catch (e) {
    // StatusCodeがエラーの場合、API側からbodyにmessageが設定されていればそれを返して正常終了とする。
    // それ以外はエラーとして扱う。
    if (e.response && e.response.data && e.response.data.message) {
      return {
        message: e.response.data.message,
        success: (e.response.data.success === 'true') || (e.response.data.success === true)
      };
    }
    throw e;
  }
};

export const getArchiveStatus = async (params: { koujiBangou: string; key: string })
  : Promise<{ status: string; bucket: string; fileKey: string; createdAt: string; ttl: number }> => {
  const path = `/${params.koujiBangou}/${params.key}`;
  const response = await API.get('GetArchiveStatusApi', path, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response;
};

export const getArchiveStatusSubdiv = async (params: { koujiBangou: string; key: string })
  : Promise<{ status: string; bucket: string; fileKey: string; createdAt: string; ttl: number }> => {
  const path = `/${params.koujiBangou}/${params.key}`;
  const response = await API.get('GetArchiveStatusSubdivApi', path, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response;
};

export const getArchiveStatusObsrec = async (params: { koujiBangou: string; key: string })
  : Promise<{ status: string; bucket: string; fileKey: string; createdAt: string; ttl: number }> => {
  //  // 人判断の観察記録ダウンロード機能は未実装
  const path = `/${params.koujiBangou}/${params.key}`;
  const response = await API.get('GetArchiveStatusObsrecApi', path, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response;
};

export const createArchive = async (
  {
    koujiBangou
  }: {
    koujiBangou: string
  }
): Promise<{}> => {
  const path = '';
  const response = await API.post('CreateArchiveApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    body: { koujiBangou }
  });

  return response;
};
export const createArchiveSubdiv = async (
  {
    koujiBangou
  }: {
    koujiBangou: string
  }
): Promise<{}> => {
  const path = '';
  const response = await API.post('CreateArchiveSubdivApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    body: { koujiBangou }
  });

  return response;
};

export const createArchiveObsrec = async (
  {
    koujiBangou
  }: {
    koujiBangou: string
  }
): Promise<{}> => {
  const path = '';
  const response = await API.post('CreateArchiveObsrecApi', path, {
    headers: {
      'Content-Type': 'application/json'
    },
    body: { koujiBangou }
  });

  return response;
};

// 最新の KansatsuKirokuSubdiv レコードから rockMassGroup を取得するAPIクライアント関数
export const getLatestKansatsuKirokuSubdiv = async (
  { koujiBangou }: { koujiBangou: string }
): Promise<string> => {
  try {
    const response = await API.get('GetLatestKansatsuKirokuSubdivApi', '', {
      headers: {
        'Content-Type': 'application/json'
      },
      queryStringParameters: {
        tunnel_no: koujiBangou
      }
    });

    // API.get が自動で JSON パースする場合、response は文字列 'xxx' または '' になるはず
    if (typeof response === 'string') {
      return response; // 文字列をそのまま返す
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching latest KansatsuKirokuSubdiv:', error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/apis/index.ts